module.exports = __webpack_public_path__ + "img/ap32-register-btn.edcbf47c.png";